export enum CfmServiceDate {
  Pickup = "pickup",
  Delivery = "delivery",
  Treatment = "treatment",
  Recycling = "recycling",
}
